import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import { getStaticLeachingStationDetails } from "../ProductionLine/services";
import { toast } from "react-toastify";

const StaticLeaching = ({ setStaticLeaching, batchId }) => {
  const [staticLeachingData, setStatingLeachingData] = useState([]);

  useEffect(() => {
    handleGetStaticLeachingData();
  }, [batchId]);

  const handleGetStaticLeachingData = async () => {
    try {
      const resp = await getStaticLeachingStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setStatingLeachingData(resp.data.payload);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setStatingLeachingData([]);
      console.log("handlesubmit", error);
    }
  };

  return (
    <>
      <div className="modal-container" style={{ height: "40vh", top: "35vh" }}>
        <div className="modal-header">
          <div className="modal-title">STATIC LEACHING PROCESS SHEET</div>
          <div
            onClick={() => setStaticLeaching(false)}
            style={{ cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="modal-table-wrapper">
          <div
            style={{
              width: "100%",
              overflow: "auto",
              maxHeight: "400px",
            }}
            className="gloves-report-data"
          >
            <Table className="dipping-params">
              <TableHead>
                <TableRow>
                  <TableCell>Batch no.</TableCell>
                  <TableCell>Conductivity</TableCell>
                  <TableCell>Cycle Start Time</TableCell>
                  <TableCell>Cycle End Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="gloves-report-body">
                {staticLeachingData?.map((e) => {
                  console.log("shdjkasdjksj", e);
                  return (
                    <TableRow>
                      <TableCell>
                        {e.batch_type ? e.batch_type : "--"}
                      </TableCell>

                      <TableCell>
                        {e.conductivity ? e.conductivity : "--"}
                      </TableCell>

                      <TableCell>
                        {e
                          ? e?.cycle_start_time
                            ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_end_time
                            ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
      <div
        className="modal-overlay"
        onClick={() => setStaticLeaching(false)}
      ></div>
    </>
  );
};

export default StaticLeaching;
